export const filterProjects = projects => {
	return projects
		.sort((p1, p2) => p2.stargazers_count - p1.stargazers_count)
		.filter(project => {
			return project.stargazers_count > 2
		})
}
